var waCmp = {
	// Does init the cookie consent from https://cookieconsent.insites.com/documentation/javascript-api/
	init: function() {
		window.addEventListener('load', function() {
			window.cookieconsent.initialise({
				'palette': {
					'popup': {
						'background': '#000'
					},
					'button': {
						'background': '#ffffff'
					}
				},
				'static': true,
				'content': {
					'message': i18next.t('common.we_use_cookies'),
					'dismiss': i18next.t('common.accept'),
					'link': i18next.t('common.privacy_statement') + '.',
					'href': waApp.getLanguage() + '/pages/privacy-statement'
				},
				elements: {
					messagelink: '<div class="container" style="padding: 1rem;"><div class="col-md-10"><span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span></div>',
					dismiss: '<div class="col-md-2"><a aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a></div></div>',
				}
			});
		});
	}
};
